import styled from 'styled-components';

import {
  ReceiptDate as BaseReceiptDate,
  ReceiptHeadInfoContainer as BaseReceiptHeadInfoContainer,
} from './receipt-head-info.styled.default';

export * from './receipt-head-info.styled.default';

export const ReceiptHeadInfoContainer = styled(BaseReceiptHeadInfoContainer)`
  p {
    font-size: 16px;
  }
`;

export const ReceiptDate = styled(BaseReceiptDate)`
  font-weight: bold;
`;
